module.exports = __webpack_public_path__ + "static/media/Center_Light.4fe3c338.svg";